export default __webpack_public_path__ + "static/media/Version (6) - Ultimate Map_29.7c91efeb.jpg";